module.exports = __webpack_public_path__ + "static/media/insta1.e9f5891b.jpg";